import { render, staticRenderFns } from "./select-people.vue?vue&type=template&id=20b6a7c0&scoped=true"
import script from "./select-people.vue?vue&type=script&lang=js"
export * from "./select-people.vue?vue&type=script&lang=js"
import style0 from "./select-people.vue?vue&type=style&index=0&id=20b6a7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6a7c0",
  null
  
)

export default component.exports